import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMeta from 'vue-meta'

import store from '@/state/store'
import routes from './routes';
import {ability} from '@/state/store';
// import LandingApi from "../api/LandingApi";


Vue.use(VueRouter)
Vue.use(VueMeta, {
  // The component option name that vue-meta looks for meta info on.
  keyName: 'page',
})


const router = new VueRouter({
  routes,
  // Use the HTML5 history API (i.e. normal-looking routes)
  // instead of routes with hashes (e.g. example.com/#/about).
  // This may require some server configuration in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  mode: 'history',
  // Simulate native-like scroll behavior when navigating to a new
  // route and using back/forward buttons.
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})

// Before each route evaluates...
router.beforeEach(async(routeTo, routeFrom, next) => {
  const publicPages = ['/login', '/forgot-password'];
  const authpage = !publicPages.includes(routeTo.path);
  const loggedUser = JSON.parse(localStorage.getItem('user'));
  const loggedIn = localStorage.getItem('user');

  // if (!loggedIn) {
  //   LandingApi.isDomainValid().then(() => {
  //     return next('/login');
  //   }).catch(() => {
  //     return next('/');
  //   })
  // }


  if (routeTo.matched.some((record) => record.meta.authRequired) && !loggedIn && authpage) {
    next({ name: 'login' });
  }

  // if (typeof store.state.auth.selectedRole === 'undefined') {
  //   await store.dispatch('auth/check');
  // } else {
  //   await store.dispatch('auth/checkAuthorization');
  // }

  // if (routeTo.matched.some((record) => record.meta.resource !== undefined
  //   && ability.cannot(record.meta.action || 'LIST', record.meta.resource))) {
  //   if (!routeFrom.name) {
  //     next({ name: 'Dashboard' });
  //   }
  // } else {
  //   next();
  // }

  // if (routeTo.meta.breadcrumbs !== undefined) {
  //   routeTo.meta.breadcrumbs.forEach((item) => {
  //     if (typeof item.name === 'object') {
  //       // eslint-disable-next-line no-param-reassign
  //       item.name[1] = item.name[0](routeTo);
  //     }
  //   });
  //   next();
  // }


  
  if (typeof store.state.permissions.permissionsUser === 'undefined') 
  {
    if (loggedUser) {
      if (publicPages.includes(routeTo.path)) {
        next({ name: 'default' });
      }
      const userId = loggedUser.id;
      store.dispatch('permissionsUser', userId ).then(() => {
        next();
      }).catch(() => {
        store.dispatch('logout');
      });
    }
  } 
  
  if (typeof routeTo.meta.action !== "undefined" || typeof routeTo.meta.resource !== "undefined") {
    const canNavigate = ability.can(routeTo.meta.action, routeTo.meta.resource);

    if(!canNavigate) {
      next({ name: 'default'})
    } else {
      next();
    }
  }
  
  // await store.dispatch('initializeApp');

  // store.commit("SET_USER", JSON.parse(localStorage.getItem("user"))); ??? TODO
  
  next();

})

router.beforeResolve(async (routeTo, routeFrom, next) => {
  // Create a `beforeResolve` hook, which fires whenever
  // `beforeRouteEnter` and `beforeRouteUpdate` would. This
  // allows us to ensure data is fetched even when params change,
  // but the resolved route does not. We put it in `meta` to
  // indicate that it's a hook we created, rather than part of
  // Vue Router (yet?).
  try {
    // For each matched route...
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        // If a `beforeResolve` hook is defined, call it with
        // the same arguments as the `beforeEnter` hook.
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            // If the user chose to redirect...
            if (args.length) {
              // If redirecting to the same route we're coming from...
              // Complete the redirect.
              next(...args)
              reject(new Error('Redirected'))
            } else {
              resolve()
            }
          })
        } else {
          // Otherwise, continue resolving the route.
          resolve()
        }
      })
    }
    // If a `beforeResolve` hook chose to redirect, just return.
  } catch (error) {
    return
  }

  // If we reach this point, continue resolving the route.
  next()
})

export default router
